/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DnspControlInterval
 */
export interface DnspControlInterval {
    /**
     *
     * @type {string}
     * @memberof DnspControlInterval
     */
    dnspEnvelopeId?: string;
    /**
     * True if this was interpolated from the default operating envelope
     * @type {boolean}
     * @memberof DnspControlInterval
     */
    isDefault?: boolean;
    /**
     * Date and time of the start of the interval. This interval ends at the StartUtc of the next interval
     * @type {Date}
     * @memberof DnspControlInterval
     */
    startUtc?: Date;
    /**
     * Charge limit in kW
     * @type {number}
     * @memberof DnspControlInterval
     */
    maxChargeKw?: number;
    /**
     * Discharge limit in kW (for V2G). Null if not set.
     * @type {number}
     * @memberof DnspControlInterval
     */
    maxDischargeKw?: number;
}

/**
 * Check if a given object implements the DnspControlInterval interface.
 */
export function instanceOfDnspControlInterval(
    value: object,
): value is DnspControlInterval {
    return true;
}

export function DnspControlIntervalFromJSON(json: any): DnspControlInterval {
    return DnspControlIntervalFromJSONTyped(json, false);
}

export function DnspControlIntervalFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspControlInterval {
    if (json == null) {
        return json;
    }
    return {
        dnspEnvelopeId:
            json["dnspEnvelopeId"] == null ? undefined : json["dnspEnvelopeId"],
        isDefault: json["isDefault"] == null ? undefined : json["isDefault"],
        startUtc:
            json["startUtc"] == null ? undefined : new Date(json["startUtc"]),
        maxChargeKw:
            json["maxChargeKw"] == null ? undefined : json["maxChargeKw"],
        maxDischargeKw:
            json["maxDischargeKw"] == null ? undefined : json["maxDischargeKw"],
    };
}

export function DnspControlIntervalToJSON(
    value?: DnspControlInterval | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        dnspEnvelopeId: value["dnspEnvelopeId"],
        isDefault: value["isDefault"],
        startUtc:
            value["startUtc"] == null
                ? undefined
                : value["startUtc"].toISOString(),
        maxChargeKw: value["maxChargeKw"],
        maxDischargeKw: value["maxDischargeKw"],
    };
}
